import React from "react";
import { Button, Form } from "react-bootstrap";
import { useSelector } from "react-redux";
// import PropTypes from "prop-types";
// import styles from './style/TabTitle.module.css'

const TabTitle = ({
  children,
  isAutoSave,
  setAutoSave,
  onSave,
  isProcessing,
  isShowAutoSave,
  isDisableAuto,
}) => {
  const {
    editingCourse,
    createCourse,
    updateCourse,
    getDetailsCourseForUpdate,
  } = useSelector((state) => state.course);

  const handleChange = (event) => {
    setAutoSave(event.target.checked);
  };

  return (
    <div className="title border-top border-bottom py-3 mb-4 d-flex justify-content-between align-items-center">
      <h5 className="m-0">{children}</h5>

      <div className="d-flex align-items-center gap-3">
        {/* <Form.Check
          name="autoSave"
          type="switch"
          id="custom-switch"
          label="Auto save"
          onChange={handleChange}
          value={isAutoSave}
          checked={isAutoSave}
          disabled={isDisableAuto}
        /> */}

        <Button
          variant="primary"
          type="button"
          onClick={onSave}
          disabled={updateCourse.processing}
        >
          {updateCourse.processing ? "Saving..." : "Save change"}
        </Button>
      </div>
    </div>
  );
};

/* required: display name */
TabTitle.displayName = "TabTitle";

/* required: props types */
TabTitle.propTypes = {};

/* required: default props */
TabTitle.defaultProps = {};

export { TabTitle };
